module.exports = __webpack_public_path__ + "img/solution--improve-patient-experience.6d3f2f8c.jpg";